module.exports = __webpack_public_path__ + "img/couples-025.d2553016.jpg";